export default __webpack_public_path__ + "static/media/315.ab0de02f.png";